import { createAsyncThunk } from '@reduxjs/toolkit';
import authServiceApiInstance from '../../../config/apiConfig';
import operationServiceApiInstance from '../../../config/openApionfig';

// Get Company Details
export const fetchCompanyDetails = createAsyncThunk(
  'companyDetails/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const response = await authServiceApiInstance.get('/admin/company');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch company details');
    }
  }
);
export const fetchCompanyDetailsById = createAsyncThunk(
  'companyDetails/fetchById',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await authServiceApiInstance.get(`/admin/company/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch company details by ID');
    }
  }
);
// Update Company Details
export const updateCompanyDetails = createAsyncThunk(
  'companyDetails/update',
  async (
    { company_detail_id, formData }: { company_detail_id: number; formData: any },
    { rejectWithValue }
  ) => {
    console.log(company_detail_id, formData, 'get it');
    try {
      formData.append('company_detail_id', company_detail_id.toString());
      const response = await authServiceApiInstance.put('/admin/company', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update company details');
    }
  }
);

export const createCompanyDetails = createAsyncThunk(
  'companyDetails/create',
  async (formData: any, { rejectWithValue }) => {
    try {
      const response = await authServiceApiInstance.post('/admin/company', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create company details');
    }
  },
);
export const fetchActiveCompanyForUser = createAsyncThunk(
  'companyDetails/fetchActiveForUser',
  async (userId: number, { rejectWithValue }) => {
    try {
      const response = await operationServiceApiInstance.get(`/admin/user/${userId}/active-company`);
      return response.data;
    } catch (error: any) {
      if (error?.response?.status === 401) {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
      return rejectWithValue(error.response?.data || 'Failed to fetch active company for user');
    }
  }
);

export const changeUserCompanyPreference = createAsyncThunk(
  'companyDetails/changeUserCompanyPreference',
  async (
    {
      userId,
      company_details_id,
      financial_year_id,
    }: { userId: number; company_details_id?: number; financial_year_id?: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await authServiceApiInstance.put(
        `/admin/user/${userId}/change-company`,
        {
          company_details_id,
          financial_year_id,
        }
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to change company preference');
    }
  }
);

